import { PageConfig } from '@container/pages/main-menu/config/get-menu-items';
import { History, LocationState } from 'history';
import userEnv from 'userEnv';
import { AppRoutePaths } from './app-route-paths';

export function gotoPage(pageConfig: Partial<PageConfig>, history: History<LocationState>) {
  if (pageConfig.newWindowLink) {
    window.open(userEnv.appUrl, '_self');
  } else {
    return history.push(`${AppRoutePaths[pageConfig.pageLink].link}`);
  }
}
